// Experiences that support the loading times dashboard

const ExperienceLoadingTimesList = [
	9524757503,
	// 6766156863, Strongman are currently not showing correct loading times
	13982397897, 15232459955,
];

export default ExperienceLoadingTimesList;
